import L from "leaflet";

// Wider bounding box covering all visible area at typical zoom levels
// (Mediterranean to Jordan / Saudi to Lebanon). The mobile reference draws
// the grid across the full viewport, not only over Israel.
export const ISRAEL_BOUNDS = [
  [29.4, 34.0],
  [33.5, 36.0],
];

export const GRID_BOUNDS = [
  [28.0, 32.5], // SW (further south & west)
  [34.5, 37.5], // NE (further north & east)
];

const STEP_KM = 10;

/**
 * Build a 10x10 km square grid as a Leaflet LayerGroup of polylines.
 *  - Color: #888888
 *  - Opacity: 0.6
 *  - Weight: 1px
 */
export function buildGridLayer() {
  const layer = L.layerGroup();
  const [[south, west], [north, east]] = GRID_BOUNDS;

  const latStep = STEP_KM / 111; // ~0.09°
  const midLat = (south + north) / 2;
  const lngStep = STEP_KM / (111 * Math.cos((midLat * Math.PI) / 180));

  const style = {
    color: "#888888",
    weight: 1,
    opacity: 0.6,
    interactive: false,
    renderer: L.canvas({ padding: 0.5 }),
  };

  for (let lat = south; lat <= north + 1e-6; lat += latStep) {
    L.polyline(
      [
        [lat, west],
        [lat, east],
      ],
      style,
    ).addTo(layer);
  }

  for (let lng = west; lng <= east + 1e-6; lng += lngStep) {
    L.polyline(
      [
        [south, lng],
        [north, lng],
      ],
      style,
    ).addTo(layer);
  }

  return layer;
}
